module.exports = "<svg :class=\"iconClass\">\n  <use :xlink:href=\"iconHref\" />\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/src/wc-ui/components/icon/icon.html
// module id = 984
// module chunks = 0